<script setup>
import { computed } from 'vue';
import Select from 'dashboard/components-next/select/Select.vue';

const props = defineProps({
  collaborators: { type: Array, required: true },
});

const modelValue = defineModel({ type: [Number, String], default: '' });

const options = computed(() =>
  props.collaborators.map(collaborator => ({
    value: collaborator.id,
    label: collaborator.name,
  }))
);
</script>

<template>
  <div class="flex justify-center mb-6">
    <Select v-model="modelValue" :options="options" />
  </div>
</template>
